import { Component, computed, ElementRef, input, output, signal, viewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import { BackButtonBoxComponent } from '@app/framework/back-button-box/back-button-box.component';

@Component({
  selector: 'app-sidebar-header',
  imports: [NgClass, BackButtonBoxComponent],
  templateUrl: './sidebar-header.component.html',
  styleUrl: './sidebar-header.component.scss',
})
export class SidebarHeaderComponent {
  showBackButton = input(false);
  backButtonClicked = output();

  backButtonHovered = signal(false);
  mainTitleContainer = viewChild<ElementRef>('mainTitleContainer');

  hideMainTitleComputed = computed(() => {
    return this.mainTitleContainer()?.nativeElement?.childNodes?.length === 0;
  });

  protected smallTitleClicked() {
    this.backButtonClicked.emit();
  }
}
